import {ContainerSizeType} from "../transportation/models/container";

export function getContainerSize(value: ContainerSizeType | null | undefined | string) {
    switch(value) {
        case ContainerSizeType.SIZE10:
            return "10 ft";
        case ContainerSizeType.SIZE20:
            return "20 ft";
        case ContainerSizeType.SIZE30:
            return "30 ft";
        case ContainerSizeType.SIZE40:
            return "40 ft";
        case ContainerSizeType.SIZE45:
            return "45 ft";
        default: return "";
    }
}